/* LLCL Product Reveal V2 · Single PLP controller · 2026-10-15
   Native Prestige swatches/media remain the only color inputs.
   One dialog per page; size choice exists only inside that dialog. */
(() => {
  'use strict';
  if (window.__LLPC_PRODUCT_REVEAL_V2__) return;
  const dialog = document.querySelector('dialog[data-llpc-drawer]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  window.__LLPC_PRODUCT_REVEAL_V2__ = true;

  const en = (document.documentElement.lang || 'es').toLowerCase().startsWith('en');
  const copy = en
    ? { more:'View more', size:'Size', unavailable:'Sold out', noSize:'No size selection required', view:'View the piece', request:'Request this piece', color:'Color', select:'Select your size' }
    : { more:'Ver más', size:'Talla', unavailable:'Agotada', noSize:'No requiere seleccionar talla', view:'Ver la pieza', request:'Solicitar pieza', color:'Color', select:'Selecciona tu talla' };
  const nodes = {
    name: dialog.querySelector('[data-llpc-detail-name]'),
    price: dialog.querySelector('[data-llpc-detail-price]'),
    photo: dialog.querySelector('[data-llpc-detail-photo]'),
    color: dialog.querySelector('[data-llpc-detail-color]'),
    photoNote: dialog.querySelector('[data-llpc-photo-note]'),
    sizes: dialog.querySelector('[data-llpc-detail-sizes]'),
    swatches: dialog.querySelector('[data-llpc-detail-swatches]'),
    colorsSection: dialog.querySelector('[data-llpc-colors-section]'),
    status: dialog.querySelector('[data-llpc-detail-status]'),
    action: dialog.querySelector('[data-llpc-detail-action]'),
    actionLabel: dialog.querySelector('[data-llpc-action-text]'),
    request: dialog.querySelector('[data-llpc-detail-request]'),
    requestLabel: dialog.querySelector('[data-llpc-request-text]')
  };
  let active = null;
  let returnFocus = null;
  const norm = s => String(s ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase();

  function readMap(card) {
    if (Object.prototype.hasOwnProperty.call(card, '__llpcProductMap')) return card.__llpcProductMap;
    let data = null;
    try {
      const raw = card.querySelector('script[data-ll-card-variant-map]')?.textContent;
      const parsed = raw && JSON.parse(raw);
      if (parsed && Array.isArray(parsed.variants) && parsed.variants.length) data = parsed;
    } catch (error) { console.warn('[LLCL Reveal] Variant data could not be read', error); }
    card.__llpcProductMap = data;
    return data;
  }

  function chosenColor(card, map) {
    if (!map || !map.colorPosition) return '';
    const checked = card.querySelector('.llpc-swatches input[type="radio"]:checked');
    if (checked) {
      // Prestige radio values are usually color names, while map.colors keys are option IDs.
      const nativeColor = checked.value;
      if (map.variants.some(v => norm(v[map.colorPosition]) === norm(nativeColor))) return nativeColor;
      const matched = (map.colors || []).find(c => String(c[0]) === nativeColor);
      if (matched) return String(matched[1]);
      const variant = map.variants.find(v => String(v[0]) === checked.dataset.variantId);
      if (variant) return String(variant[map.colorPosition] || '');
      return checked.labels?.[0]?.querySelector('.sr-only')?.textContent?.trim() || '';
    }
    return card.dataset.llpcColor || String(map.variants[0]?.[map.colorPosition] || '');
  }

  function matchingVariants(map, color) {
    return map.variants.filter(v => !map.colorPosition || !color || norm(v[map.colorPosition]) === norm(color));
  }

  function selectedVariant(map, color, size) {
    const pool = matchingVariants(map, color);
    if (size && map.sizePosition) {
      const sized = pool.filter(v => norm(v[map.sizePosition]) === norm(size));
      return sized.find(v => v[4] === true) || sized[0] || null;
    }
    return pool.find(v => v[4] === true) || pool[0] || map.variants[0] || null;
  }

  function variantUrl(map, variant, forRequest) {
    const u = new URL(forRequest ? map.requestUrl : map.productUrl, window.location.origin);
    if (variant) u.searchParams.set('variant', String(variant[0]));
    return u.pathname + u.search + u.hash;
  }

  function synchronizeCard(card) {
    const map = readMap(card);
    if (!map) return;
    // A sellable color without dedicated photography must not look sold out.
    if (map.colorPosition) {
      card.querySelectorAll('.llpc-swatches input[type="radio"]').forEach(input => {
        const swatch = input.nextElementSibling;
        if (!swatch?.classList.contains('color-swatch')) return;
        const option = (map.colors || []).find(item => String(item[0]) === input.value);
        const colorName = option?.[1] || swatch.querySelector('.sr-only')?.textContent?.trim();
        if (!colorName) return;
        const available = map.variants.some(v =>
          norm(v[map.colorPosition]) === norm(colorName) && v[4] === true
        );
        swatch.classList.toggle('is-disabled', !available);
      });
    }
    const color = chosenColor(card, map);
    card.dataset.llpcColor = color;
    const display = card.querySelector('[data-llpc-color-label]');
    if (display) { display.textContent = color; display.hidden = !color; }
    const variant = selectedVariant(map, color, card.dataset.llpcChosenSize || '');
    if (variant) {
      card.dataset.llSelectedVariantId = String(variant[0]);
      card.querySelectorAll('.product-card__media, .product-title').forEach(link => {
        if (link instanceof HTMLAnchorElement) link.setAttribute('href', variantUrl(map, variant, false));
      });
    }
    if (active?.card === card) {
      active.color = color;
      if (active.size && !matchingVariants(map, color).some(v => norm(v[map.sizePosition]) === norm(active.size))) active.size = '';
      paintDialog();
    }
  }

  function missingColorPhoto(card, color) {
    if (!color) return false;
    const source = card.querySelector('script[data-llcl-card-variant-media-groups]');
    if (!source) return false; // No authoritative mapping; do not guess.
    try {
      const data = JSON.parse(source.textContent || '{}');
      if (Array.isArray(data.no_photo_colors) && data.no_photo_colors.some(c => norm(c) === norm(color))) return true;
      const entries = Object.entries(data.groups || {});
      if (!entries.length) return false;
      const found = entries.find(([name]) => norm(name) === norm(color));
      return !found || !Array.isArray(found[1]?.ordered_media_ids) || found[1].ordered_media_ids.length === 0;
    } catch (_) { return false; }
  }

  function paintColorChoices() {
    if (!active) return;
    const { card, map, color } = active;
    const inputs = [...card.querySelectorAll('.llpc-swatches input[type="radio"]')];
    nodes.swatches.replaceChildren();
    nodes.colorsSection.hidden = !map.colorPosition || !inputs.length;
    if (nodes.colorsSection.hidden) return;
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i], label = input.nextElementSibling;
      if (!label?.classList.contains('color-swatch')) continue;
      const option = (map.colors || []).find(x => String(x[0]) === input.value);
      const title = String(option?.[1] || label.querySelector('.sr-only')?.textContent?.trim() || '');
      const available = map.variants.some(v => norm(v[map.colorPosition]) === norm(title) && v[4] === true);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'llpc-drawer__swatch';
      button.dataset.llpcColorIndex = String(i);
      button.dataset.stock = available ? 'yes' : 'no';
      button.dataset.light = label.classList.contains('border') || /^(white|blanco|ivory|off[ -]?white)$/i.test(title.trim()) ? 'yes' : 'no';
      button.setAttribute('aria-pressed', norm(title) === norm(color) ? 'true' : 'false');
      button.setAttribute('aria-label', title + (available ? '' : (en ? ', sold out' : ', agotado')));
      const dot = document.createElement('span');
      dot.className = 'llpc-drawer__swatch-dot';
      const native = getComputedStyle(label);
      const fill = native.getPropertyValue('--swatch-background').trim();
      dot.style.setProperty('--llpc-swatch-fill', fill || native.backgroundColor || '#eee');
      dot.setAttribute('aria-hidden', 'true');
      button.append(dot);
      nodes.swatches.append(button);
    }
  }

  function paintDialog() {
    if (!active) return;
    const { card, map, color, size } = active;
    const pool = matchingVariants(map, color);
    const variant = selectedVariant(map, color, size);
    nodes.name.textContent = map.name || card.querySelector('.product-title')?.textContent?.trim() || '';
    nodes.price.textContent = variant?.[5] || map.fallbackPrice || '';
    nodes.color.textContent = color || '';
    nodes.color.closest('[data-llpc-color-row]').hidden = !color;
    nodes.photoNote.hidden = !missingColorPhoto(card, color);
    paintColorChoices();

    nodes.sizes.replaceChildren();
    if (map.sizePosition) {
      const sizes = [...new Set(pool.map(v => v[map.sizePosition]).filter(Boolean))];
      if (!sizes.length) {
        const msg = document.createElement('p'); msg.className = 'llpc-drawer__no-size';
        msg.textContent = copy.unavailable; nodes.sizes.append(msg);
      }
      sizes.forEach(label => {
        const available = pool.some(v => norm(v[map.sizePosition]) === norm(label) && v[4] === true);
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'llpc-size';
        b.dataset.llpcSize = String(label);
        b.dataset.stock = available ? 'yes' : 'no';
        b.setAttribute('aria-pressed', norm(label) === norm(size) ? 'true' : 'false');
        b.setAttribute('aria-label', available ? String(label) : String(label) + ', ' + copy.unavailable);
        b.textContent = String(label);
        nodes.sizes.append(b);
      });
    } else {
      const msg = document.createElement('p'); msg.className = 'llpc-drawer__no-size';
      msg.textContent = copy.noSize; nodes.sizes.append(msg);
    }

    const sold = !variant || variant[4] !== true;
    nodes.status.textContent = sold ? copy.unavailable : '';
    nodes.status.hidden = !sold;
    nodes.action.href = variantUrl(map, variant, false);
    nodes.actionLabel.textContent = copy.view;
    nodes.request.hidden = !sold;
    if (sold && variant) {
      // PDP contains #ll-atelier-<product.id>; URL query preserves the selected variant.
      nodes.requestLabel.textContent = copy.request;
      nodes.request.href = variantUrl(map, variant, true);
    }
  }

  function open(card, trigger) {
    const map = readMap(card);
    if (!map) {
      card.querySelector('.product-title')?.click();
      return;
    }
    const color = chosenColor(card, map);
    active = { card, map, color, size: card.dataset.llpcChosenSize || '' };
    const image = card.querySelector('.product-card__image--primary');
    const src = image?.currentSrc || image?.src || '';
    if (src) { nodes.photo.src = src; nodes.photo.alt = image.alt || map.name || ''; nodes.photo.hidden = false; }
    else { nodes.photo.removeAttribute('src'); nodes.photo.hidden = true; }
    returnFocus = trigger;
    paintDialog();
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-llpc-close]')?.focus({ preventScroll:true });
  }

  document.addEventListener('click', e => {
    const colorChoice = e.target.closest?.('[data-llpc-color-index]');
    if (colorChoice && active && dialog.contains(colorChoice)) {
      const input = active.card.querySelectorAll('.llpc-swatches input[type="radio"]')[Number(colorChoice.dataset.llpcColorIndex)];
      if (input && !input.disabled) {
        input.click(); // Prestige native color/media is the single source of truth.
        requestAnimationFrame(() => synchronizeCard(active.card));
      }
      return;
    }
    const opener = e.target.closest?.('[data-llpc-open]');
    if (opener) {
      const card = opener.closest('product-card.llpc-card');
      if (card) { e.preventDefault(); open(card, opener); }
      return;
    }
    if (e.target.closest?.('[data-llpc-close]')) { dialog.close(); return; }
    const size = e.target.closest?.('[data-llpc-size]');
    if (size && active && dialog.contains(size)) {
      active.size = size.dataset.llpcSize;
      active.card.dataset.llpcChosenSize = active.size;
      const v = selectedVariant(active.map, active.color, active.size);
      if (v) {
        active.card.dataset.llSelectedVariantId = String(v[0]);
        active.card.querySelectorAll('.product-card__media, .product-title').forEach(link => {
          if (link instanceof HTMLAnchorElement) link.href = variantUrl(active.map, v, false);
        });
      }
      paintDialog();
      dialog.querySelector('[data-llpc-size][aria-pressed="true"]')?.focus({preventScroll:true});
    }
  });

  document.addEventListener('change', e => {
    if (!e.target.matches?.('product-card.llpc-card .llpc-swatches input[type="radio"]')) return;
    const card = e.target.closest('product-card.llpc-card');
    if (card) requestAnimationFrame(() => synchronizeCard(card));
  });
  // Search-only native swatch bridge. Search's filter rerender can leave the
  // radio visually unchanged even when a label receives the click.
  // Resolve the label's own control, set it explicitly and announce a change
  // through the native input; C16 still owns media and variant URL updates.
  document.addEventListener('click', e => {
    const label = e.target.closest?.('.shopify-section--main-search product-card.llpc-card .llpc-swatches label.color-swatch');
    if (!label) return;
    const card = label.closest('product-card.llpc-card');
    const input = label.control || (label.htmlFor ? document.getElementById(label.htmlFor) : label.previousElementSibling);
    if (!card || !input?.matches('input[type="radio"]') || input.disabled) return;
    requestAnimationFrame(() => {
      if (!card.isConnected) return;
      if (!input.checked) input.checked = true;
      input.dispatchEvent(new Event('change', {bubbles:true}));
      synchronizeCard(card);
    });
  });
  dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { active = null; returnFocus?.focus({preventScroll:true}); returnFocus = null; });

  function prime() {
    document.querySelectorAll('.shopify-section--main-collection product-card.llpc-card').forEach(card => {
      const trigger = card.querySelector('[data-llpc-open]');
      if (!trigger) return;
      trigger.hidden = false;
      if (card.dataset.llpcInitialized !== 'yes') {
        card.dataset.llpcInitialized = 'yes';
        synchronizeCard(card);
      }
    });
  }
  let queued = false;
  const schedulePrime = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; prime(); });
  };
  const resultsRoot = document.querySelector('.shopify-section--main-collection');
  if (resultsRoot) {
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(n =>
        n.nodeType === 1 && (n.matches?.('product-card.llpc-card') || n.querySelector?.('product-card.llpc-card')))))
        schedulePrime();
    }).observe(resultsRoot, {childList:true, subtree:true});
  }
  document.addEventListener('shopify:section:load', schedulePrime);
  prime();
})();